/* Task-owned behavior only. Releasit owns commerce and any floating button. */
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-liteplex-cta]').forEach((slot) => {
      if (slot.dataset.styled) return;
      slot.dataset.styled = 'true';
      const styleButtons = () => slot.querySelectorAll('._rsi-buy-now-button').forEach((button) => {
        const styles = {background:'var(--orange)',color:'#fff','border-radius':'5px','box-shadow':'none','font-size':'13.65px','font-weight':'900','min-height':'53px'};
        Object.entries(styles).forEach(([key,value]) => button.style.setProperty(key,value,'important'));
        button.setAttribute('role','button');
        button.tabIndex = 0;
        if (!button.dataset.liteplexKeys) {
          button.dataset.liteplexKeys = 'true';
          button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();button.click();}
          });
        }
      });
      new MutationObserver(styleButtons).observe(slot,{childList:true,subtree:true});
      styleButtons();
    });
    scope.querySelectorAll('[data-liteplex-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('[data-liteplex-main]');
      const buttons = [...gallery.querySelectorAll('[data-liteplex-thumb]')];
      const select = (button) => {
        main.src = button.dataset.src;
        main.srcset = '';
        main.alt = button.dataset.alt;
        buttons.forEach(b => { b.classList.toggle('is-active', b === button); b.setAttribute('aria-pressed', String(b === button)); });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length-1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].focus(); select(buttons[next]);
        });
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
